import { closeCashPointMutation } from "@/api/gql/fiskaly";
import { LogLevel, LogService } from "@/services/logging";
import {
  ICashPointClosure,
  IUntypedCashPointClosure,
} from "@/types/db/cashpoint-closure";
import FiskalyModule from "@/store/modules/fiskaly";
import { dexieDB } from "@/services/dexie-database";

export async function saveCashPointClosure(
  cashPointClosure: ICashPointClosure
) {
  const newCashPointClosure: IUntypedCashPointClosure = {
    _id: cashPointClosure.closureUuid,
    closure: cashPointClosure,
  };
  try {
    LogService.info(
      `Fiskaly: Storing cashPointClosure into local database: ${cashPointClosure.closureUuid}`,
      { params: cashPointClosure }
    );
    const id = await dexieDB.cashPointClosures.add(newCashPointClosure);
  } catch (err: any) {
    LogService.info(
      `Fiskaly: Error when saving cashPointClosure: ${cashPointClosure.closureUuid}`,
      {
        params: {
          error: err,
        },
      }
    );
  }
}

/**
 * pushHandler to sync cashPointClosures
 * We call closeCashPointMutation only if all transactions are synced to backend
 */
export async function cashPointClosuresSynchHandler() {
  // get 1 cashPointClosure from DexieDB (the last one)
  const dbCloure = await dexieDB.cashPointClosures.limit(1).toArray();
  if (!dbCloure.length) return;
  const closure = dbCloure[0].closure as ICashPointClosure | null;
  if (!closure) return;

  try {
    // check if we have any unsynced transactions for this cashfloat
    const unsyncedTransactions =
      FiskalyModule.unsyncedTransactions[closure.cashfloatUid];
    if (unsyncedTransactions && unsyncedTransactions.length) {
      LogService.info(
        `Fiskaly: Some transactions are not synced for cashPointClosure: ${closure.closureUuid}, we will try again`,
        {
          params: {
            unsyncedTransactions: unsyncedTransactions,
            closure: closure,
          },
        },
        LogLevel.Error
      );
      return;
    }

    LogService.info(
      `Fiskaly: going to close cashPoint: ${closure.closureUuid}`,
      {
        params: closure,
      }
    );

    await closeCashPointMutation({
      ...closure,
    });
    // delete the cash point closure from dexie
    const deletedFiles = await dexieDB.cashPointClosures
      .where({ _id: dbCloure[0]._id })
      .delete();
  } catch (error) {
    LogService.info(
      `Fiskaly: Error when closing cashPointClosure: ${closure.closureUuid}, we will try again`,
      {
        params: {
          error: error,
          closure: closure,
        },
      },
      LogLevel.Error
    );
  }
}
